// Generated by OrchestKit Claude Plugin
// Created: 2026-09-09

/** Contrats de l'écran catalogue — RG-019 à RG-038. */

export type Canal = 'DETAIL' | 'SEMI_GROS' | 'GROS';

export const CANAUX: Canal[] = ['DETAIL', 'SEMI_GROS', 'GROS'];

/** Filtre de la liste : un canal, ou `TOUS` (par défaut). */
export type FiltreCanal = Canal | 'TOUS';

export const LIBELLE_CANAL: Record<Canal, string> = {
  DETAIL: 'Détail',
  SEMI_GROS: 'Semi-gros',
  GROS: 'Gros',
};

export interface Produit {
  id: string;
  reference: string;
  designation: string;
  canal: string;
  quantiteMinimale: number;
  /** `null` seulement quand la liste inclut les fiches sans prix (admin). */
  prixUnitaire: number | null;
  /**
   * Stock de la boutique choisie — nom EXACT du champ envoyé par l'API.
   *
   * Il s'appelait `stock` ici : le champ était donc toujours indéfini, et la
   * colonne Stock affichait « — » pour tous les produits. L'API ramène
   * l'absence de stock à zéro ; ce champ n'est jamais nul.
   */
  stockDisponible: number;
  /** Absent de la charge utile d'un vendeur — RG-143. */
  coutMoyen?: number;

  /**
   * Seuil de réapprovisionnement — RG-186.
   *
   * ABSENT quand aucun seuil n'est fixé. Un zéro par défaut serait
   * indiscernable d'un seuil réglé à zéro, alors que les deux disent le
   * contraire l'un de l'autre : « aucune alerte voulue » contre « alerte
   * désactivée ici ».
   */
  seuilReapprovisionnement?: number;

  /** Nom de la catégorie — toujours présent, contrairement au coût. */
  categorieLibelle: string;

  /**
   * Identifiants bruts, pour pré-remplir le formulaire de modification.
   * Absents sans `produit.modifier` (RG-038).
   */
  categorieId?: string;
  uniteBaseId?: string;
}

/** Un canal d'un produit, avec son prix en vigueur et sa quantité minimale. */
export interface CanalDuProduit {
  canal: Canal;
  quantiteMinimale: number;
  /** `null` : le canal existe mais n'a pas de prix actif (RG-029). */
  prixUnitaire: number | null;
}

/**
 * Un produit, UNE seule fois dans la liste, avec tous ses canaux.
 *
 * Le stock est celui du produit : tous ses canaux le partagent.
 */
export interface ProduitGroupe {
  id: string;
  reference: string;
  designation: string;
  categorieLibelle: string;
  stockDisponible: number;
  canaux: CanalDuProduit[];
  /** Absent de la charge utile d'un vendeur — RG-143. */
  coutMoyen?: number;
  seuilReapprovisionnement?: number;
  categorieId?: string;
  uniteBaseId?: string;
}

/**
 * Convertit un produit groupé vers la forme qu'attendent les formulaires
 * (prix, seuil, modification, photos…), qui portent UN canal.
 *
 * `entree` choisit le canal ; à défaut, le premier. Les formulaires qui
 * agissent sur le produit entier (seuil, modification, photos) n'en lisent pas.
 */
export function versProduit(groupe: ProduitGroupe, entree?: CanalDuProduit): Produit {
  const canal = entree ?? groupe.canaux[0];
  const produit: Produit = {
    id: groupe.id,
    reference: groupe.reference,
    designation: groupe.designation,
    canal: canal?.canal ?? 'DETAIL',
    quantiteMinimale: canal?.quantiteMinimale ?? 1,
    prixUnitaire: canal?.prixUnitaire ?? null,
    stockDisponible: groupe.stockDisponible,
    categorieLibelle: groupe.categorieLibelle,
  };
  if (groupe.coutMoyen !== undefined) produit.coutMoyen = groupe.coutMoyen;
  if (groupe.seuilReapprovisionnement !== undefined) {
    produit.seuilReapprovisionnement = groupe.seuilReapprovisionnement;
  }
  if (groupe.categorieId !== undefined) produit.categorieId = groupe.categorieId;
  if (groupe.uniteBaseId !== undefined) produit.uniteBaseId = groupe.uniteBaseId;
  return produit;
}

export interface ProduitCree {
  id: string;
  reference: string;
  avertissements: { code: string; message: string }[];
}

export interface PrixCree {
  montant: number;
  date_debut: string;
  /**
   * Prix clôturé par celui-ci — RG-031. `date_fin: null` signale une
   * correction en place (même jour de début) : rien n'a été clôturé.
   */
  remplace: { montant: number; date_fin: string | null } | null;
  avertissements: { code: string; message: string }[];
}

export interface PhotoProduit {
  id: string;
  type_mime: string;
  taille_octets: number;
  largeur: number | null;
  hauteur: number | null;
  position: number;
}

export interface Referentiel {
  categories: { id: string; libelle: string }[];
  unites: { id: string; libelle: string }[];
}
